import {
  HIDE_LOADER_PAYMENT_FORMULAS,
  SET_ERROR_PAYMENT_FORMULAS,
  SET_PAYMENT_FORMULAS,
  SET_PAYMENT_FORMULAS_FOR_ID,
  SET_PAYMENT_FORMULAS_PARAMS,
  SHOW_LOADER_PAYMENT_FORMULAS
} from "./actionType";

const INIT_STATE = {
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  payment_formula: null,
  absolute_params: null,
  isError: false,
  loading: false,
  error: null,
};

const PaymentFormulas = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_PAYMENT_FORMULAS:
      return {
        ...state,
        data: action.payload,
      };
    case SET_PAYMENT_FORMULAS_FOR_ID:
      return {
        ...state,
        payment_formula: action.payload,
      };
    case SET_PAYMENT_FORMULAS_PARAMS:
      return {
        ...state,
        absolute_params: action.payload,
      };
    case SHOW_LOADER_PAYMENT_FORMULAS:
      return {
        ...state,
        loading: true,
      };
    case HIDE_LOADER_PAYMENT_FORMULAS:
      return {
        ...state,
        loading: false,
      };
    case SET_ERROR_PAYMENT_FORMULAS:
      return {
        ...state,
        isError: action.payload,
      };
    default:
      return state;
  }
};

export default PaymentFormulas;
